import "@/App.css";
import { AdminLocaleGuard } from "@/app/AdminLocaleGuard";
import { AppRoutes } from "@/app/AppRoutes";
import { PendingSubscriptionCheckoutEffect } from "@/components/subscription/PendingSubscriptionCheckoutEffect";
import { SubscriptionCheckoutModal } from "@/components/subscription/SubscriptionCheckoutModal";
import { AppUpdatePromptHost } from "@/domains/shared/appUpdatePrompt/AppUpdatePromptHost";
import { SubscriptionCheckoutProvider } from "@/domains/subscription/SubscriptionCheckoutContext";
import { useLocale } from "@mivo/i18n";
import { Toaster } from "sonner";

function App() {
    // Subscribe at the route-tree root so `getTranslation` copy under AppRoutes
    // re-renders on locale change. LocaleObserver alone cannot refresh stable
    // `children` props; this re-creates route elements without remounting forms.
    useLocale();

    return (
        <>
            <AdminLocaleGuard />
            <SubscriptionCheckoutProvider>
                <AppRoutes />
                <PendingSubscriptionCheckoutEffect />
                <SubscriptionCheckoutModal />
            </SubscriptionCheckoutProvider>
            <AppUpdatePromptHost />
            <Toaster
                position="top-right"
                richColors
                toastOptions={{
                    style: { borderRadius: "14px", fontFamily: "Inter, sans-serif" },
                }}
            />
        </>
    );
}

export default App;
